import { render, staticRenderFns } from "./NotificationFeatureCell.vue?vue&type=template&id=108e7f9e"
import script from "./NotificationFeatureCell.vue?vue&type=script&lang=js"
export * from "./NotificationFeatureCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports